import { ApplicationCandidateItem } from "../applicationCandidate"
import { LoadingComponent } from "../loading"
import { ApplicationCandidateListProps } from "./model"

export const ApplicationCandidateList = (candidatesProps: ApplicationCandidateListProps) => {
    candidatesProps.candidates.forEach(candidate => {
        candidate.url = candidatesProps.url
    })

    return (
        <div className="w-full">
            {candidatesProps.loading
                ? <LoadingComponent />
                : candidatesProps.candidates.length === 0
                    ? <p className="text-figmaDarkGray text-[14px] text-center mt-[32px]">Nu există candidați.</p>
                    : candidatesProps.candidates.map((candidateProps) => (
                        <ApplicationCandidateItem data={candidateProps} key={candidateProps.id} />
                    ))
            }
        </div>
    )
}